<template>
  <div id="app">
    <div class="body_log">
      <div class="log_box">
        <div class="log_img">
          <div class="img1">
            <img src="https://file.wigordigital.com/log_1.jpg" alt="logimg">
          </div>
          <div class="tc">
            <div class="welcome">
              welcome to page
            </div>
            <div class="wel_sub">
              log in to your account
            </div>
          </div>
        </div>
        <div id="login" class="login">
          <img src="https://file.wigordigital.com/logo.png" alt="logo" class="log_logo">

          <div class="login-page">
            <div class="admin_log">
              管理员登录
            </div>
            <div class="admin_sub">
              请输入用户名密码登录系统
            </div>
            <div class="login-box">
              <el-form id="loginForm" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">

                <div class="form-item">
                  <el-input id="username" class="form-input" autocomplete="off" placeholder="请输入用户名" v-model="ruleForm.username" ></el-input>
                </div>

                <div class="form-item">
                  <el-input type="password" class="form-input password-input"  id="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入登录密码"></el-input>
                  <button type="button" class="password-toggle" id="passwordToggle" @click="getpass()"
                          aria-label="显示或隐藏密码">
                    <img src="https://file.wigordigital.com/ic_password_eyeoff.svg" alt="off" class="off">
                    <img src="https://file.wigordigital.com/ic_password_eyeon.svg" alt="on" class="on">
                  </button>
                </div>
                <div class="form-item captcha-item">
                  <el-input v-model="ruleForm.captcha" id="captchaInput" placeholder="验证码" class="yzm captcha-input" ></el-input>
                  <div class="captcha-code" id="captchaCode" title="点击刷新验证码">
                    <img :src='this.src' alt="captcha"  @click="getnewimg()" />
                  </div>
                </div>
                <el-button type="primary" class="login-btn" @click="submitForm('ruleForm')">登录</el-button>
              </el-form>
            </div>
          </div>

          <div class="log_bz">
            © wigor Digital Technology 维格数字科技
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoginView",
  data() {
    return {
      ruleForm: {
        username: '',
        password: '',
        captcha: '',

      },
      src: "/api/Index/verify.html",
      rules: {
        username: [
          { required: true,message:'用户名不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true,message:'密码不能为空', trigger: 'blur' },
          { min:6,message:'密码不少于6位', trigger: 'blur' }
        ],
        captcha: [
          { required: true,message:'验证码不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    getnewimg(){
      const src = '/api/Index/verify.html?rand='+Math.random();
      this.src = src;
    },
    getpass(){
      const password = document.getElementById("password");
      const passwordToggle = document.getElementById("passwordToggle");
      const isPassword = password.type === "password";
      password.type = isPassword ? "text" : "password";
      passwordToggle.classList.toggle("active", isPassword);
    },
    submitForm(event) {
      // event.preventDefault();
      let formdata = new FormData();
      formdata.append('username',this.ruleForm.username);
      formdata.append('password',this.ruleForm.password);
      formdata.append('captcha',this.ruleForm.captcha);
      this.$refs[event].validate(() => {
        this.axios({
          method:'post',
          url:'/api/Login/setLogin.html',
          data:formdata
        }).then((res)=>{
          // console.log(res.data);
          if(res.data.code != 200) {
            const src = '/api/Index/verify.html?rand='+Math.random();
            this.src = src;
            alert(res.data.msg);
          }
          else{
            window.sessionStorage.setItem('token',res.data.id);
            // localStorage.setItem('token','');
            this.$router.push({name:'HomeView'});
          }
        })
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}

</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 16px;
}

body {
  min-height: 100vh;
  background: #ffffff;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}
.el-input{
  height: 100%;
}
.body_log {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 30px;
}

.body_log .log_box {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  max-width: 1920px;
  width: 100%;
  margin: auto;
  flex-wrap: wrap;
  height:100%;
}

.body_log .log_box .log_img {
  width: 48%;
  position: relative;
  border-radius: 30px;
}

.body_log .log_box .log_img .img1 {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.body_log .log_box .log_img img {
  width: 100%;
  position: absolute;
  height: 100%;
  object-fit: cover;
}

.body_log .log_box .log_img .tc {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 94%;
  text-align: center;
  color: #fff;
}

.body_log .log_box .log_img .tc .welcome {
  font-size: 3rem;
  text-transform: uppercase;
  font-weight: bold;
  line-height: 150%;
}

.body_log .log_box .log_img .tc .wel_sub {
  font-size: 1.125rem;
  color: #ffffff;
  opacity: .7;
  margin-top: 10px;
}


.body_log .log_box .login {
  width: 48%;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 6%;
  gap: 1rem;
}

.body_log .log_box .login .log_logo {
  max-width: 12.5rem;
  width: 100%;
}

.body_log .log_box .login .log_bz {
  font-size: 1rem;
  text-align: center;
  color: #acb4c8;
  text-transform: uppercase;
}

.body_log .admin_log {
  font-size: 3rem;
  color: #000000;
  line-height: 150%;
}

.body_log .admin_sub {
  font-size: 1.125rem;
  color: #999999;
}

.body_log .login-page {
  width: 94%;
  max-width: 38.75rem;
  margin: auto;
}

.body_log .login-box {
  margin-top: 10%;
}

.body_log .form-item {
  width: 100%;
  height: 4.5rem;
  margin-bottom: 1.5rem;
  position: relative;
  border: 1px solid #eaeaea;
  background: #f2f5fb;
  border-radius: .625rem;
}

.body_log .form-item input {
  width: 100%;
  height: 100%;
  outline: none;
  padding: 0 1.5rem;
  font-size: 1.125rem;
  color: #333;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: transparent;
  border: none;
}

.body_log .form-item input::placeholder {
  color: #999 !important;
}

.body_log .form-input:focus {
  border-color: #4353ff;
  box-shadow: 0 0 0 2px rgba(67, 83, 255, 0.08);
}

.body_log .password-input {
  padding-right: 5rem;
}

.body_log .password-input {
  padding-right: 4rem;
}

.body_log .password-input::-ms-reveal,
.body_log .password-input::-ms-clear {
  display: none;
}

.body_log .password-input {
  appearance: none;
  -webkit-appearance: none;
}

.body_log .password-toggle {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
}

.body_log .password-toggle img {
  display: block;
  width: 1.5rem;
  height: 1.5rem;
}

.body_log .password-toggle .on {
  display: none;
}

.body_log .password-toggle.active .off {
  display: none;
}

.body_log .password-toggle.active .on {
  display: block;
}

.body_log .captcha-item {
  display: flex;
  align-items: center;
  border: 1px solid #eaeaea;
  border-radius: .625rem;
  outline: none;
  background: #fff;
  padding-right: 20px;
}

.body_log .captcha-input {
  flex: 1;
  height: 100%;
  border: none;
  padding: 0 ;
  font-size: 1.125rem;
  color: #333;
  outline: none;
  background: transparent;
}

.body_log .captcha-input::placeholder {
  color: #a7a7a7;
}

.body_log .captcha-code {
  max-width: 13rem;
}

.body_log .login-btn{
  width: 100%;
  height: 4.5rem;
  border: none;
  border-radius: .625rem;
  background: #4353ff;
  color: #fff;
  font-size: 1.125rem;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
}

.body_log .login-btn:hover {
  opacity: 0.92;
}

.body_log .login-btn:active {
  transform: scale(0.995);
}

@media (max-width: 1560px) {
  html {
    font-size: 14px;
  }
}

@media (max-width: 1300px) {
  html {
    font-size: 12px;
  }
}

@media (max-width: 1130px) {
  .body_log {
    height: auto;
    padding: 0;
  }

  .log_box .log_img {
    width: 100%;
  }

  .log_box .login {
    width: 100%;
    padding: 50px 0 20px;
  }

  .log_box .log_img .img1 {
    padding-bottom: 20rem;
    height: auto;
    gap: 3rem;
  }
}

@media (max-width: 600px) {
  .log_box .log_img .tc .welcome {
    font-size: 2rem;
  }

  .admin_log {
    font-size: 2rem;
  }

  .form-item {
    margin-bottom: 1rem;
  }

  .log_box .login .log_bz {
    margin-top: 2rem;
  }
}
</style>
